var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeamlessCollab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1697_30870",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1697_30870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4807 26.8469C23.8233 28.1994 26.8187 27.3968 28.1711 25.0542C29.5236 22.7117 28.721 19.7163 26.3785 18.3638C24.0359 17.0113 21.0405 17.8139 19.688 20.1565C18.3355 22.499 19.1382 25.4944 21.4807 26.8469Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51905 26.8469C10.8616 25.4944 11.6642 22.499 10.3118 20.1565C8.95932 17.8139 5.96389 17.0113 3.62131 18.3638C1.27879 19.7163 0.476176 22.7117 1.82864 25.0542C3.1811 27.3968 6.17653 28.1994 8.51905 26.8469Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8975 7.14133C19.8975 4.43641 17.7046 2.24365 14.9997 2.24365C12.2948 2.24365 10.102 4.43641 10.102 7.14133C10.102 9.84631 12.2948 12.0391 14.9997 12.0391C17.7046 12.0391 19.8975 9.84631 19.8975 7.14133Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3017 17.9023C25.3082 17.7522 25.3115 17.6012 25.3115 17.4494C25.3115 13.4714 23.0589 10.0197 19.7596 8.3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45713 26.1463C11.058 27.169 12.96 27.7617 15.0005 27.7617C17.041 27.7617 18.9431 27.169 20.5439 26.1463",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2412 8.30035C6.94197 10.02 4.68933 13.4718 4.68933 17.4497C4.68933 17.6013 4.69267 17.7522 4.69912 17.9023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessCollab);
export default __webpack_public_path__ + "static/media/seamless-collab.69979f873e4224b357a9dc9f7e922552.svg";
export { ForwardRef as ReactComponent };